import React, { PropsWithChildren } from 'react';

import { PILL_COLORS, PillColor } from './pill-constants';

import './pill.scss';

interface PillProps {
  className?: string;
  color?: PillColor;
}

function Pill(props: PropsWithChildren<PillProps>) {
  const { children, className, color = PILL_COLORS.WHITE } = props;
  let styleName = 'container';

  if (color === PILL_COLORS.GREEN) {
    styleName = 'container-green';
  } else if (color === PILL_COLORS.RED) {
    styleName = 'container-red';
  } else if (color === PILL_COLORS.WHITE) {
    styleName = 'container-white';
  }

  return (
    <span className={className} styleName={`${styleName}`}>
      {children}
    </span>
  );
}

export { PILL_COLORS };

export default Pill;
